import { Box, Text } from "@shared/primitive-components"
import { TspList } from "../../../api/policy"
import * as Styles from "../../styles"
import { RemoveTspButton } from "./RemoveTspButton"
import { TSPS_SECTION_DTI } from "./TspsSection"
import { MaybeObfuscatedValue } from "../../../components/Obfuscated"

type CurrentTspsListProps = {
  tspsList: TspList
  onRemove: (tspId: string) => void
}
export const CurrentTspsList = ({ tspsList, onRemove }: CurrentTspsListProps) => (
  <>
    {tspsList.map((tsp) => (
      <Box data-testid={TSPS_SECTION_DTI.LIST} css={Styles.TSPItem} key={tsp.id}>
        <Text>
          <MaybeObfuscatedValue value={tsp.name} />
        </Text>
        <RemoveTspButton tspId={tsp.id} onRemove={onRemove} />
      </Box>
    ))}
  </>
)
